import { AfterViewInit, Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DOCUMENT } from '@angular/common';
import { SchemaSettings } from '../shell.model';

@Component({
  selector: 'app-schema-settings-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './schema-settings-modal.component.html',
  styleUrls: ['./schema-settings-modal.component.scss']
})
export class SchemaSettingsModalComponent implements AfterViewInit, OnInit {
  @Input() settings?: SchemaSettings;

  formValues: SchemaSettings = {
    requireProvenance: false,
    fastConversion: false,
    multiple_rows: false,
    schemaSplittingThreshold: 20,
    n_shot: 1
  };
  private initialValues: SchemaSettings = { ...this.formValues };

  constructor(public modal: NgbActiveModal, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    if (this.settings) {
      this.formValues = { ...this.formValues, ...this.settings };
    }
    this.initialValues = { ...this.formValues };
  }

  ngAfterViewInit(): void {
    // Remove initial focus from any element when the modal opens.
    setTimeout(() => {
      const active = this.document.activeElement as HTMLElement | null;
      if (active) {
        active.blur();
      }
    });
  }

  onCancel(): void {
    this.modal.dismiss('cancel');
  }

  onSave(): void {
    const hasChanged = JSON.stringify(this.formValues) !== JSON.stringify(this.initialValues);
    if (!hasChanged) {
      this.modal.dismiss('no-change');
      return;
    }
    this.modal.close(this.formValues);
  }
}
